import { Api } from '@/api/api.client';
import { resetDemoClassTour } from '@/composables/growth/useDemoClassTour';
import { resetOwnerActivationChannel } from '@/composables/growth/useOwnerActivationFlow';
import { queryClient } from '@/plugins/vueQuery';
import { useClassCreationStore } from '@/stores/classCreationStore';
import { useAuthStore } from '@/stores/useAuthStore';
import { useCurrentClassStore } from '@/stores/useCurrentClassStore';
import { useLastViewedStore } from '@/stores/useLastViewedStore';
import { useOnceStore } from '@/stores/useOnceStore';
import { useSidebarStore } from '@/stores/useSidebarStore';
import { useWhoAmIStore } from '@/stores/useWhoAmIStore';
import { toast } from 'vue3-toastify';

/**
 * Forgets the signed-in user in this browser: cached queries, toasts, persisted stores and the csrf header.
 * Logout runs it after the server call; the router guard runs it on its own when the persisted csrf token
 * belongs to a session the server no longer knows (expired, revoked, logged out elsewhere).
 */
export const clearLocalSession = async (): Promise<void> => {
  await queryClient.cancelQueries();
  queryClient.clear();

  // Dismiss any outstanding toasts (e.g. sticky async-operation toasts that never auto-close)
  toast.clearAll();

  useLastViewedStore().$reset();
  useCurrentClassStore().$reset();
  useAuthStore().$reset();
  useWhoAmIStore().$reset();
  useClassCreationStore().$reset();
  useOnceStore().$reset();
  useSidebarStore().$reset();
  resetOwnerActivationChannel();
  resetDemoClassTour();

  Api.setHeader('x-csrf-token', null);
};
